const articles = document.querySelectorAll('.article');
const filterButtons = document.querySelectorAll('#filter button[data-filter]');

const filter = {
	year: '$all',
	company: '$all'
};

filterButtons.forEach(button => button.addEventListener('click', () => {
	setFilter(button.dataset.filter, button.dataset[button.dataset.filter]);
}));

function setFilter(key, value) {
	filter[key] = value;
	setClassesForFilter(filter);
	checkForResults();
	scrollToTop();
}

function setClassesForFilter(filter) {
	articles.forEach((article) => {
		if (Object.entries(filter).every(([key, value]) => {
			return article.dataset[key] == value || value === '$all';
		})) {
			article.classList.remove('hidden');
		} else {
			article.classList.add('hidden');
		}
	});

	for (const [key, value] of Object.entries(filter)) {
		const buttons = document.querySelectorAll(`#filter [data-filter="${key}"]`);

		let displayValue;

		buttons.forEach(button => {
			button.classList.remove('active');
			if (button.dataset[key] === value) {
				button.classList.add('active');
				displayValue = button.innerText;
			}
		});

		document.querySelector(`#filter .current[data-filter="${key}"]`).innerText = displayValue;
	}
}

function checkForResults() {
	for (const article of articles) {
		if (article.classList.contains('hidden') === false) {
			document.querySelector('#no-results').classList.add('hidden');
			return;
		}
	}

	document.querySelector('#no-results').classList.remove('hidden');
}

function scrollToTop() {
	document.querySelector('main').scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth'
	})
}
